import React, { useState } from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import Table from "../../../core/common/dataTable/index";
import ProfileTab from "../../../core/common/profiletab";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import useApi from "../../../core/customhook/useApi";
import Swal from "sweetalert2";

const Educations = () => {
  const routes = all_routes;
  const {
    data: onboardingstatus,
    loading: onboardingstatusLoading,
    error: onboardingstatusError,
  } = useApi("/api/onboarding/final-status", {
    method: "GET",
    autoCall: true,
  });

  const status = onboardingstatus?.data?.onb_status;
  const [callData, setCallData] = useState(1);
  const [editData, setEditData] = useState<any>({});
  const getModalContainer = () => {
    const modalElement = document.getElementById("modal-datepicker");
    return modalElement ? modalElement : document.body;
  };

  const columns1 = [
    {
      title: "S. No.",
      dataIndex: "sno",
    },
    {
      title: "From Date",
      dataIndex: "from_date",
    },
    {
      title: "To Date",
      dataIndex: "to_date",
    },
    {
      title: "Education Detail",
      dataIndex: "education_details",
    },
    {
      title: "Qualification",
      dataIndex: "qualification",
    },
    {
      title: "Qualification Gained",
      dataIndex: "qualification_gained",
    },
    {
      title: "Establishment",
      dataIndex: "establishment",
    },
    {
      title: "Branch of Study [Major]",
      dataIndex: "study_branch",
    },
    {
      title: "Country",
      dataIndex: "country",
    },
    {
      title: "Highest Qualification",
      dataIndex: "highest_qualification",
    },
    {
      title: "Marks %",
      dataIndex: "marks",
      render: (text: string) => <span className="text-primary">{text}</span>,
    },
    {
      title: "Institute/Location of Training",
      dataIndex: "institute_details",
      render: (text: string) => <small>{text}</small>,
    },
    {
      title: "Action",
      dataIndex: "action",
      render: (_: any, record: any) => {
        const canEdit =
          status === "In Progress" ||
          status === "Rejected" ||
          status === "Re Open" ||
          status === "Not Started";

        return (
          <i
            className={`ti ti-edit ${canEdit ? "text-primary" : "text-secondary"}`}
            style={{
              cursor: canEdit ? "pointer" : "not-allowed",
              opacity: canEdit ? 1 : 0.6,
            }}
            title={
              canEdit
                ? "Edit"
                : "Editing is disabled for this status"
            }
            onClick={() => {
              if (canEdit) {
                setEditData(record);
              }
            }}
            data-bs-toggle={canEdit ? "modal" : undefined}
            data-bs-target={canEdit ? "#editexampleModalLg" : undefined}
          />
        );
      },
    }

  ];

  const [data, setData] = useState({
    from_date: "",
    to_date: "",
    education_details: "",
    qualification: "",
    qualification_gained: "",
    establishment: "",
    study_branch: "",
    country: "",
    highest_qualification: "",
    marks: "",
    institute_details: "",
  });

  const getInputData = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
    >
  ) => {
    const { name, value } = e.target;
    setData({ ...data, [name]: value });
  };

  const getEditData = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >
  ) => {
    const { name, value } = e.target;
    setEditData({ ...editData, [name]: value });
  };

  const {
    data: educationData,
    loading: educationLoading,
    error: educationError,
  } = useApi("/api/onboarding/view-education", {
    method: "GET",
    autoCall: true,
    dependencies: [callData],
  });

  const addSNo = educationData?.data?.map((item: any, index: any) => {
    return {
      ...item,
      sno: index + 1,
    };
  });

  const {
    data: Education,
    loading,
    error,
    callApi: postEducation,
  } = useApi("/api/onboarding/add-education", {
    method: "POST",
    autoCall: false,
  });

  const postData = async (e: React.FormEvent<HTMLFormElement>) => {
    const payload = {
      ...data,
      from_date: dayjs(data.from_date).format("DD/MM/YYYY"),
      to_date: dayjs(data.to_date).format("DD/MM/YYYY"),
    };
    e.preventDefault();
    console.log(payload);
    try {
      const response = await postEducation(payload);
      console.log(response);
      if (response.success) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: response?.message || "Data submitted successfully!",
          confirmButtonColor: "#3085d6",
        }).then(() => {
          document.getElementById("closeModalBtn")?.click();
        });
        setCallData(callData + 1);
        setData({
          from_date: "",
          to_date: "",
          education_details: "",
          qualification: "",
          qualification_gained: "",
          establishment: "",
          study_branch: "",
          country: "",
          highest_qualification: "",
          marks: "",
          institute_details: "",
        })
      }
    } catch (error: any) {
      Swal.fire({
        icon: "error",
        title: "Submission Failed",
        text:
          error?.response?.data?.message ||
          "Something went wrong while submitting the form.",
        confirmButtonColor: "#d33",
      });
    }
  };

  const {
    data: educationEditData,
    loading: educationEditLoading,
    error: educationEditError,
    callApi: editEducationjData,
  } = useApi("/api/onboarding/edit-education", {
    method: "POST",
    autoCall: false,
  });

  const handleEdit = async (e: any) => {
    e.preventDefault();
    try {
      const payload = {
        ...editData,
        education_id: editData.ID,
      };
      const response = await editEducationjData(payload);
      if (response.success) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: response?.message || "Data submitted successfully!",
          confirmButtonColor: "#3085d6",
        }).then(() => {
          document.getElementById("editcloseModalBtn")?.click();
        });
        setCallData(callData + 1);
      }
    } catch (error: any) {
      Swal.fire({
        icon: "error",
        title: "Submission Failed",
        text:
          error?.response?.data?.message ||
          "Something went wrong while submitting the form.",
        confirmButtonColor: "#d33",
      });
    }
  };
  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Education</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={routes.adminDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">Administration</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Education
                  </li>
                </ol>
              </nav>
            </div>
            <div className="head-icons ms-2">
              <CollapseHeader />
            </div>
          </div>
          <div className="row">
            <div className="col-xl-3 theiaStickySidebar">
              <div
                className="stickybar"
                style={{ position: "sticky", top: "50px" }}
              >
                <ProfileTab />
              </div>
            </div>
            <div className="col-xl-9">
              <div className="card">
                <div className="card-body d-flex justify-content-between">
                  <div className="">
                    <h3>Education Detail</h3>
                  </div>
                  {
                    status === "In Progress" || status === "Rejected" || status === "Re Open" || status === "Not Started" ? <button
                      className="btn btn-primary custom_button"
                      data-bs-toggle="modal"
                      data-bs-target="#exampleModalLg"
                    >
                      {" "}
                      <i className="ti ti-circle-plus me-2" />
                      Add Education
                    </button> : ""
                  }

                </div>
                <div className="card">
                  <Table
                    dataSource={addSNo || []}
                    columns={columns1}
                    Selection={false}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="footer d-flex align-items-center justify-content-center   border-top bg-white p-3">
          <p className="mb-0">© {new Date().getFullYear()} WeConnect. All rights reserved.</p>
        </div>
      </div>

      <div
        className="modal fade"
        id="exampleModalLg"
        tabIndex={-1}
        aria-labelledby="exampleModalLgLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title" id="exampleModalLgLabel">
                Education Detail
              </h4>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                id="closeModalBtn"
              />
            </div>
            <div className="modal-body">
              <div className="card">
                <div className="card-body">
                  <form onSubmit={postData}>
                    <div className="border-bottom mb-3">
                      <div className="row">
                        <div className="col-md-6">
                          <div className="row align-items-center mb-3">
                            <div className="col-md-4">
                              <label className="form-label mb-md-0">
                                From Date<sup className="text-danger">*</sup>
                              </label>
                            </div>
                            <div className="col-md-8">
                              <div className="input-icon-end position-relative">
                                <DatePicker
                                  className="form-control datetimepicker"
                                  format="DD-MM-YYYY" // Specify the date format
                                  getPopupContainer={getModalContainer} // Position the popup container if needed
                                  placeholder="DD-MM-YYYY"
                                  name="from_date" // Field name
                                  value={
                                    data.from_date
                                      ? dayjs(data.from_date, "YYYY-MM-DD")
                                      : null
                                  } // Set the value as per the current state
                                  onChange={(date) =>
                                    setData((prev) => ({
                                      ...prev,
                                      from_date: date
                                        ? date.format("YYYY-MM-DD")
                                        : "", // Update the date in state when selected
                                    }))
                                  }
                                  disabledDate={(current) =>
                                    current &&
                                    current.isAfter(dayjs().startOf("day"))
                                  } // Disable past dates if needed
                                  required
                                />
                                <span className="input-icon-addon">
                                  <i className="ti ti-calendar text-gray-7" />
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="row align-items-center mb-3">
                            <div className="col-md-4">
                              <label className="form-label mb-md-0">
                                To Date<sup className="text-danger">*</sup>
                              </label>
                            </div>
                            <div className="col-md-8">
                              <div className="input-icon-end position-relative">
                                <DatePicker
                                  className="form-control datetimepicker"
                                  format="DD-MM-YYYY" // Specify the date format
                                  getPopupContainer={getModalContainer} // Position the popup container if needed
                                  placeholder="DD-MM-YYYY"
                                  name="to_date" // Field name
                                  value={
                                    data.to_date
                                      ? dayjs(data.to_date, "YYYY-MM-DD")
                                      : null
                                  } // Set the value as per the current state
                                  onChange={(date) =>
                                    setData((prev) => ({
                                      ...prev,
                                      to_date: date
                                        ? date.format("YYYY-MM-DD")
                                        : "", // Update the date in state when selected
                                    }))
                                  }
                                  disabledDate={(current) =>
                                    current &&
                                    current.isAfter(dayjs().startOf("day"))
                                  } // Disable past dates if needed
                                  required
                                />
                                <span className="input-icon-addon">
                                  <i className="ti ti-calendar text-gray-7" />
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="row align-items-center mb-3">
                            <div className="col-md-4">
                              <label className="form-label mb-md-0">
                                Education Detail
                                <sup className="text-danger">*</sup>
                              </label>
                            </div>
                            <div className="col-md-8">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter education detail"
                                name="education_details"
                                onChange={getInputData}
                                required
                                value={data.education_details}
                              />
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="row align-items-center mb-3">
                            <div className="col-md-4">
                              <label className="form-label mb-md-0">
                                Qualification
                                <sup className="text-danger">*</sup>
                              </label>
                            </div>
                            <div className="col-md-8">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter qualification"
                                name="qualification"
                                onChange={getInputData}
                                required
                                value={data.qualification}
                              />
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="row align-items-center mb-3">
                            <div className="col-md-4">
                              <label className="form-label mb-md-0">
                                Qualification Gained
                                <sup className="text-danger">*</sup>
                              </label>
                            </div>
                            <div className="col-md-8">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter qualification gained"
                                name="qualification_gained"
                                onChange={getInputData}
                                required
                                value={data.qualification_gained}
                              />
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="row align-items-center mb-3">
                            <div className="col-md-4">
                              <label className="form-label mb-md-0">
                                Establishment
                                <sup className="text-danger">*</sup>
                              </label>
                            </div>
                            <div className="col-md-8">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter establishment"
                                name="establishment"
                                onChange={getInputData}
                                required
                                value={data.establishment}
                              />
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="row align-items-center mb-3">
                            <div className="col-md-4">
                              <label className="form-label mb-md-0">
                                Branch of Study (Major)<sup className="text-danger">*</sup>
                              </label>
                            </div>
                            <div className="col-md-8">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter branch of study"
                                name="study_branch"
                                onChange={getInputData}
                                required
                                value={data.study_branch}
                              />
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="row align-items-center mb-3">
                            <div className="col-md-4">
                              <label className="form-label mb-md-0">
                                Country
                                <sup className="text-danger">*</sup>
                              </label>
                            </div>
                            <div className="col-md-8">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter country"
                                name="country"
                                onChange={getInputData}
                                required
                                value={data.country}
                              />
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="row align-items-center mb-3">
                            <div className="col-md-4">
                              <label className="form-label mb-md-0">
                                Highest Qualification
                                <sup className="text-danger">*</sup>
                              </label>
                            </div>
                            <div className="col-md-8">
                              <select
                                className="form-select"
                                name="highest_qualification"
                                onChange={getInputData}
                                required
                                value={data.highest_qualification}
                              >
                                <option value="">Select option</option>
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                              </select>
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="row align-items-center mb-3">
                            <div className="col-md-4">
                              <label className="form-label mb-md-0">
                                Marks %<sup className="text-danger">*</sup>
                              </label>
                            </div>
                            <div className="col-md-8">
                              <input
                                type="number"
                                className="form-control"
                                placeholder="Enter marks percentage"
                                name="marks"
                                onChange={getInputData}
                                value={data.marks}
                                required
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="row align-items-start mb-3">
                            <div className="col-xxl-2 col-md-3">
                              <label className="form-label mb-md-0">
                                Institute/Location of Training<sup className="text-danger">*</sup>
                              </label>
                            </div>
                            <div className="col-xxl-10 col-md-9">
                              <textarea
                                className="form-control"
                                rows={2}
                                placeholder="Enter institute or location"
                                name="institute_details"
                                onChange={getInputData}
                                required
                                value={data.institute_details}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Buttons */}
                    <div className="d-flex align-items-center justify-content-end">
                      <button
                        type="button"
                        className="btn btn-outline-light border me-3"
                        data-bs-dismiss="modal"
                      >
                        Cancel
                      </button>
                      <button type="submit" className="btn btn-primary custom_button">
                        Save
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="editexampleModalLg"
        tabIndex={-1}
        aria-labelledby="exampleModalLgLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title" id="exampleModalLgLabel">
                Edit Education Detail
              </h4>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                id="editcloseModalBtn"
              />
            </div>
            <div className="modal-body">
              <div className="card">
                <div className="card-body">
                  <form onSubmit={handleEdit}>
                    <div className="border-bottom mb-3">
                      <div className="row">
                        <div className="col-md-6">
                          <div className="row align-items-center mb-3">
                            <div className="col-md-4">
                              <label className="form-label mb-md-0">
                                From Date<sup className="text-danger">*</sup>
                              </label>
                            </div>
                            <div className="col-md-8">
                              <div className="input-icon-end position-relative">
                                <DatePicker
                                  className="form-control datetimepicker"
                                  format="DD-MM-YYYY"
                                  getPopupContainer={getModalContainer}
                                  placeholder="DD-MM-YYYY"
                                  name="from_date"
                                  value={
                                    editData.from_date
                                      ? dayjs(editData.from_date, "DD/MM/YYYY")
                                      : null
                                  }
                                  onChange={(date) =>
                                    setEditData((prev: any) => ({
                                      ...prev,
                                      from_date: date
                                        ? date.format("DD/MM/YYYY")
                                        : "",
                                    }))
                                  }
                                  disabledDate={(current) =>
                                    current &&
                                    current.isAfter(dayjs().startOf("day"))
                                  }
                                  required
                                />
                                <span className="input-icon-addon">
                                  <i className="ti ti-calendar text-gray-7" />
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="row align-items-center mb-3">
                            <div className="col-md-4">
                              <label className="form-label mb-md-0">
                                To Date<sup className="text-danger">*</sup>
                              </label>
                            </div>
                            <div className="col-md-8">
                              <div className="input-icon-end position-relative">
                                <DatePicker
                                  className="form-control datetimepicker"
                                  format="DD-MM-YYYY"
                                  getPopupContainer={getModalContainer}
                                  placeholder="DD-MM-YYYY"
                                  name="to_date"
                                  value={
                                    editData.to_date
                                      ? dayjs(editData.to_date, "DD/MM/YYYY")
                                      : null
                                  }
                                  onChange={(date) =>
                                    setEditData((prev: any) => ({
                                      ...prev,
                                      to_date: date
                                        ? date.format("DD/MM/YYYY")
                                        : "",
                                    }))
                                  }
                                  disabledDate={(current) =>
                                    current &&
                                    current.isAfter(dayjs().startOf("day"))
                                  }
                                  required
                                />
                                <span className="input-icon-addon">
                                  <i className="ti ti-calendar text-gray-7" />
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="row align-items-center mb-3">
                            <div className="col-md-4">
                              <label className="form-label mb-md-0">
                                Education Detail
                                <sup className="text-danger">*</sup>
                              </label>
                            </div>
                            <div className="col-md-8">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter education detail"
                                name="education_details"
                                value={editData.education_details}
                                onChange={getEditData}
                                required
                              />
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="row align-items-center mb-3">
                            <div className="col-md-4">
                              <label className="form-label mb-md-0">
                                Qualification
                                <sup className="text-danger">*</sup>
                              </label>
                            </div>
                            <div className="col-md-8">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter qualification"
                                name="qualification"
                                value={editData.qualification}
                                onChange={getEditData}
                                required
                              />
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="row align-items-center mb-3">
                            <div className="col-md-4">
                              <label className="form-label mb-md-0">
                                Qualification Gained
                                <sup className="text-danger">*</sup>
                              </label>
                            </div>
                            <div className="col-md-8">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter qualification gained"
                                name="qualification_gained"
                                value={editData.qualification_gained}
                                onChange={getEditData}
                                required
                              />
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="row align-items-center mb-3">
                            <div className="col-md-4">
                              <label className="form-label mb-md-0">
                                Establishment
                                <sup className="text-danger">*</sup>
                              </label>
                            </div>
                            <div className="col-md-8">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter establishment"
                                name="establishment"
                                value={editData.establishment}
                                onChange={getEditData}
                                required
                              />
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="row align-items-center mb-3">
                            <div className="col-md-4">
                              <label className="form-label mb-md-0">
                                Branch of Study (Major)<sup className="text-danger">*</sup>
                              </label>
                            </div>
                            <div className="col-md-8">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter branch of study"
                                name="study_branch"
                                value={editData.study_branch}
                                onChange={getEditData}
                                required
                              />
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="row align-items-center mb-3">
                            <div className="col-md-4">
                              <label className="form-label mb-md-0">
                                Country
                                <sup className="text-danger">*</sup>
                              </label>
                            </div>
                            <div className="col-md-8">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter country"
                                name="country"
                                value={editData.country}
                                onChange={getEditData}
                                required
                              />
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="row align-items-center mb-3">
                            <div className="col-md-4">
                              <label className="form-label mb-md-0">
                                Highest Qualification
                                <sup className="text-danger">*</sup>
                              </label>
                            </div>
                            <div className="col-md-8">
                              <select
                                className="form-select"
                                name="highest_qualification"
                                value={editData.highest_qualification}
                                onChange={getEditData}
                                required
                              >
                                <option value="">Select option</option>
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                              </select>
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="row align-items-center mb-3">
                            <div className="col-md-4">
                              <label className="form-label mb-md-0">
                                Marks %<sup className="text-danger">*</sup>
                              </label>
                            </div>
                            <div className="col-md-8">
                              <input
                                type="number"
                                className="form-control"
                                placeholder="Enter marks percentage"
                                name="marks"
                                value={editData.marks}
                                onChange={getEditData}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="row align-items-start mb-3">
                            <div className="col-xxl-2 col-md-3">
                              <label className="form-label mb-md-0">
                                Institute/Location of Training<sup className="text-danger">*</sup>
                              </label>
                            </div>
                            <div className="col-xxl-10 col-md-9">
                              <textarea
                                className="form-control"
                                rows={2}
                                placeholder="Enter institute or location"
                                name="institute_details"
                                value={editData.institute_details}
                                onChange={getEditData}
                                required
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Buttons */}
                    <div className="d-flex align-items-center justify-content-end">
                      <button
                        type="button"
                        className="btn btn-outline-light border me-3"
                        data-bs-dismiss="modal"
                      >
                        Cancel
                      </button>
                      <button type="submit" className="btn btn-primary">
                        Save
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Educations;
